import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StudyBlockUiService {
  public uiBlocked$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor() {
    this.unblockUI();
  }

  blockUI() {
    this.uiBlocked$.next(true);
  }

  unblockUI() {
    this.uiBlocked$.next(false);
  }
}
